import type { ReactNode } from "react";
import { FiInfo } from "react-icons/fi";
import "./index.scss";

interface InfoTooltipProps {
  open: boolean;
  children: ReactNode;
}

export function InfoTooltip({ open, children }: InfoTooltipProps) {
  if (!open) return null;

  return (
    <div className="search-toggle-tooltip" role="tooltip">
      <span className="icon" aria-hidden="true">
        <FiInfo />
      </span>
      <p className="text">{children}</p>
    </div>
  );
}
